/* eslint-disable radix */

export function addIdModulo(idModulo) {
  return {
    type: 'ADD_ID_MODULO',
    idModulo,
  };
}

export function addUserID(idUser) {
  return {
    type: 'ADD_USER_GROUP_ID',
    idUser,
  };
}

export function addCompanyId(idPessoaEmpresa) {
  return {
    type: 'ADD_COMPANY_ID',
    idPessoaEmpresa,
  };
}

export function addMenuID(idMenu) {
  return {
    type: 'ADD_MENU_ID',
    idMenu,
  };
}

export function addGroupID(idGroup) {
  return {
    type: 'ADD_GROUP_ID',
    idGroup,
  };
}
